import { useEffect } from "react";

import { tenantIdStorageKey } from "./storage";

export default function TenantIdObserver() {
  useEffect(() => {
    function observer(ev: StorageEvent) {
      const isStorageCleared = ev.key === null && ev.newValue === null;

      if (ev.key === tenantIdStorageKey || isStorageCleared) {
        // reload app to use latest token and tenant_id
        window.location.replace("/");
      }
    }

    window.addEventListener("storage", observer);
    return () => {
      window.removeEventListener("storage", observer);
    };
  });

  return <></>;
}
